// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M19.1208 6V18C19.1208 19.105 18.2258 20 17.1208 20H6.88281C5.77781 20 4.88281 19.105 4.88281 18V6C4.88281 4.895 5.77781 4 6.88281 4H17.1218C18.2258 4 19.1208 4.895 19.1208 6Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M19.1172 6H19.9982C21.1032 6 21.9982 6.895 21.9982 8V16C21.9982 17.105 21.1032 18 19.9982 18H19.1172M4.881 18H4C2.895 18 2 17.105 2 16V8C2 6.895 2.895 6 4 6H4.881"
    />
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M10.9406 9.05783L14.8226 11.3538C15.3136 11.6438 15.3136 12.3548 14.8226 12.6448L10.9406 14.9408C10.4406 15.2368 9.80859 14.8758 9.80859 14.2948V9.70383C9.80859 9.12283 10.4406 8.76183 10.9406 9.05783V9.05783Z"
      clipRule="evenodd"
    />
  </svg>
);
const IconPlayVideo = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconPlayVideo;
